import { useEffect } from 'react'
import { compose, hoc, useStore } from '@'
import { SetFormValues, useForm, useFormLoading } from '@form'
import GetRegionCoverage from '../../actions/GetRegionCoverage'
import { $regionCoverageQuery } from '../../stores'
import { DEFAULT_PAGE_SIZE } from '../CoverageCommon'

const $fieldProps = {
    region_id: { rules: [{ required: true, whitespace: true, message: 'Please enter a region_id' }] }
}

const container = compose(
    hoc(props => {
        const [query] = useStore([$regionCoverageQuery])

        const [$props, $form] = useForm(() => {
            const onSubmit = async values => {
                await GetRegionCoverage({
                    region_id: values.region_id,
                    supplier_code: values.supplier_code,
                    page: 1,
                    page_size: DEFAULT_PAGE_SIZE
                })
            }

            return {
                name: 'RegionCoverageSearch',
                onSubmit
            }
        }, [])

        const $loading = useFormLoading($form.name)

        const regionId = query && query.region_id
        const supplierCode = (query && query.supplier_code) || ''

        // A deep link or a region just created also lands in the inputs; paging does not touch them.
        useEffect(() => {
            if (regionId) {
                SetFormValues($form.name, { supplier_code: supplierCode, region_id: regionId })
            }
        }, [$form.name, regionId, supplierCode])

        return {
            $props,
            $loading,
            $fieldProps,
            ...props
        }
    })
)

export default container
